/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Holidays_PeriodsInputs */



/**
* | output |
* | --- |
* | "Periods/Holidays" |
*
* @param {Holidays_PeriodsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const holidays_periods = /** @type {((inputs?: Holidays_PeriodsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Holidays_PeriodsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Periods/Holidays")
	return /** @type {LocalizedString} */ ("Périodes/Vacances")
});